
import { updateComments as updateCommentsDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type CommentsProps = {
    activity?: string,
    fromNode?: string,
    toNode?: string,
    comment?: string;
    createdBy?: string;
    component?: string;
    variantType?: string;
    type?: string;
    mode?: string;
    source?: string
}

export const updateComments = ({
    activity,
    fromNode,
    toNode,
    comment,
    createdBy,
    component,
    variantType,
    type,
    mode,
    source,
}: CommentsProps) => (

    updateCommentsDiagram({
        activity,
        fromNode,
        toNode,
        comment,
        createdBy,
        component,
        variantType,
        type,
        mode,
        source,
    })
);
